import React from 'react';
import { SystemDashboardLayout } from '../../library';
import HeaderDashboard from '../../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import AddLookup from '../../Components/Lookup/LookupGrid'
import { SystemGridAndForm } from '../../library/form/SystemGridForm';
import AddLookupRequest from '../../Components/Lookup/LookupForm';
import AgencyOptionsGrid from '../../Components/Lookup/AgencyOptionsGrid'
import BNADecisionOptionsGrid from '../../Components/Lookup/BNADecisionOptionsGrid'
import NAICSOptionsGrid from '../../Components/Lookup/NAICSOptionsGrid'
import OpportunityRoleOptionsGrid from '../../Components/Lookup/OpportunityRoleOptionsGrid'
import OpportunityStatusOptionsGrid from '../../Components/Lookup/OpportunityStatusOptionsGrid'
import OpportunityTypeOptionsGrid from '../../Components/Lookup/OpportunityTypeOptionsGrid'
import WorkflowStageOptionsGrid from '../../Components/Lookup/WorkflowStageOptionsGrid'
import CostActivityOptionsGrid from '../../Components/Lookup/CostActivityOptionsGrid'
import { hasReadPermission } from '../../service/userService';

const AddLookupRequestDashboard = () => {
    return (<>
        <div className="DashboardWrapperChild">           
            <div className="contentWrapper">
                <HeaderDashboard title="Top" tagLine="" />
                <div className="container-fluid mt-80">
                    <div className="row">     
                        <div className="col-md-12">
                            <h3 style={{ "marginLeft": "-16px" }}>Lookup Table Management</h3>
                            { hasReadPermission('Top.Lookup.Agency') &&
                                <SystemDashboardLayout>
                                    <SystemGridAndForm label="Agency Options" form={AddLookupRequest} data={{ LookupTable: 'Agency' }} grid={AgencyOptionsGrid} securityObject="Top.Lookup.Agency" collapse={true} showAdd={true} />
                                </SystemDashboardLayout>
                            }

                            { hasReadPermission('Top.Lookup.BNADecision') &&
                                <SystemDashboardLayout>
                                    <SystemGridAndForm label="BNA Decision Options" form={AddLookupRequest} data={{ LookupTable: 'BNADecision' }} grid={BNADecisionOptionsGrid} securityObject="Top.Lookup.BNADecision" collapse={true} showAdd={true} />
                                </SystemDashboardLayout>
                            }

                            { hasReadPermission('Top.Lookup.CostActivity') &&
                                <SystemDashboardLayout>
                                    <SystemGridAndForm label="Cost Activity Options" form={AddLookupRequest} data={{ LookupTable: 'CostActivity' }} grid={CostActivityOptionsGrid} securityObject="Top.Lookup.CostActivity" collapse={true} showAdd={true} />
                                </SystemDashboardLayout>
                            }

                            { hasReadPermission('Top.Lookup.NAICS') &&
                                <SystemDashboardLayout>
                                    <SystemGridAndForm label="NAICS Options" form={AddLookupRequest} data={{ LookupTable: 'NAICS' }} grid={NAICSOptionsGrid} securityObject="Top.Lookup.NAICS" collapse={true} showAdd={true} />
                                </SystemDashboardLayout>
                            }

                            { hasReadPermission('Top.Lookup.OpportunityRole') &&
                                <SystemDashboardLayout>
                                    <SystemGridAndForm label="Opportunity Role Options" form={AddLookupRequest} data={{ LookupTable: 'TrailbossRole' }} grid={OpportunityRoleOptionsGrid} securityObject="Top.Lookup.OpportunityRole" collapse={true} showAdd={true} />
                                </SystemDashboardLayout>
                            }

                            { hasReadPermission('Top.Lookup.OpportunityStatus') &&
                                <SystemDashboardLayout>
                                    <SystemGridAndForm label="Opportunity Status Options" form={AddLookupRequest} data={{ LookupTable: 'OpportunityStatus' }} grid={OpportunityStatusOptionsGrid} securityObject="Top.Lookup.OpportunityStatus" collapse={true} showAdd={true} />
                                </SystemDashboardLayout>
                            }

                            { hasReadPermission('Top.Lookup.OpportunityType') &&
                                <SystemDashboardLayout>
                                    <SystemGridAndForm label="Opportunity Type Options" form={AddLookupRequest} data={{ LookupTable: 'OpportunityType' }} grid={OpportunityTypeOptionsGrid} securityObject="Top.Lookup.OpportunityType" collapse={true} showAdd={true} />
                                </SystemDashboardLayout>
                            }

                            { hasReadPermission('Top.Lookup.WorkflowStage') &&
                                <SystemDashboardLayout>
                                    <SystemGridAndForm label="Workflow Stage Options" form={AddLookupRequest} data={{ LookupTable: 'WorkflowStatus' }} grid={WorkflowStageOptionsGrid} securityObject="Top.Lookup.WorkflowStage" collapse={true} showAdd={true} />
                                </SystemDashboardLayout>
                            }                           
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export default AddLookupRequestDashboard;